module.exports = "<th>Состав съемщиков</th>\n<td>\n\t<terms items=\"::terms.composition\"\n\t\t   source=\"source.composition\"/>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/family.html
// module id = 341
// module chunks = 0